import Axios from "axios";
import classNames from "classnames";
import { addHours, formatISO, parseISO } from "date-fns";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { ProgressBar } from "primereact/progressbar";
import React, { useEffect, useState } from "react";
import { BiRefresh } from "react-icons/bi";
import { FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { mask, unMask } from "remask";
import DialogTermo from "../../../components/signup/dialogTermo";
import { Api } from "../../../services/api";
import { CalendarPague, FloatLabelCalendar, FloatLabelPassword, PasswordFullPague } from "../../../styles/primeReactConfig";
import { getLocal, setLocal } from "../../../utils/localStorageOps";
// import DialogTermo from "./DialogTermo";

function FirstContact() {
  const navigate = useNavigate();
  const today = new Date();
  const [nomeCadastro, setNomeCadastro] = useState();
  const [documentoCadastro, setDocumentoCadastro] = useState(getLocal('documentocadastro'));
  const [dataCriacao, setDataCriacao] = useState();
  const [showDataCriacao, setShowDataCriacao] = useState(false);
  const [phoneCadastro, setPhoneCadastro] = useState();
  const [fixoCadastro, setFixoCadastro] = useState('');
  const [emailCadastro, setEmailCadastro] = useState();
  const [confirmaEmailCadastro, setConfirmaEmailCadastro] = useState();
  const [senhaCadastro, setSenhaCadastro] = useState();
  const [senhaConfirmacao, setSenhaConfirmacao] = useState();
  const [showTermo, setShowTermo] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendData = async () => {
    const cadastroData = {
      usuario_nome: nomeCadastro,
      usuario_email: emailCadastro,
      usuario_telefone: unMask(phoneCadastro),
      pcd_celular: unMask(fixoCadastro),
      password: senhaCadastro,
      usuario_documento: documentoCadastro,
      aceite_termo: true,
      aceite_politica: true,
    }

    setLoading(true);
    try {
      await Api.post('/users/precadastro', cadastroData)
      setLocal('documentocadastro', cadastroData.usuario_documento);
      setLocal('emailcadastro', cadastroData.usuario_email);
      setLocal('telefonecadastro', cadastroData.usuario_telefone);
      setLocal('passwordcadastro', cadastroData.password);
      setLocal('nomecadastro', cadastroData.usuario_nome);

      if (documentoCadastro.length === 14) {
        if (showDataCriacao)
          setLocal('datacriacao', formatISO(addHours(new Date(dataCriacao), 3), { representation: "date" }))
        else
          setLocal('datacriacao', dataCriacao)
      }

      navigate('/cadastro/passo2');
    } catch (error) {
      console.log(error);
      if (error.response.status === 409)
        return toast.error("O Email informado já foi cadastrado em nossa plataforma, tente outro email!")
      toast.error('Erro ao cadastrar suas informações, tente novamente mais tarde')
    }
    finally {
      setLoading(false)
    }
  }


  const consultaCNPJ = async (e) => {
    const cnpj = unMask(e)
    if (cnpj.length === 14) {
      // if(ValidaCNPJ(cnpj)){
      try {
        const { data } = await Axios.get(`https://receitaws.com.br/v1/cnpj/${cnpj}`);
        setDataCriacao(parseISO(new Date(data.abertura)))
        setNomeCadastro(data.nome);
        setPhoneCadastro(mask(data.telefone.replaceAll(' ', ''), ['(99) 9999-9999', '(99) 99999-9999']))
        //   setFixoCadastro(mask(data.ddd_telefone_2.replaceAll(' ',''),['(99) 9999-9999','(99) 99999-9999']))
        //    toast.success('CNPJ encontrado!');
      } catch (error) {
        console.log(error);
        try {
          const { data } = await Axios.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`);
          setDataCriacao(data.data_inicio_atividade);
          setNomeCadastro(data.razao_social);
          setPhoneCadastro(mask(data.ddd_telefone_1.replaceAll(' ', ''), ['(99) 9999-9999', '(99) 99999-9999']))
          setFixoCadastro(mask(data.ddd_telefone_2.replaceAll(' ', ''), ['(99) 9999-9999', '(99) 99999-9999']))
          //    toast.success('CNPJ encontrado!');
        } catch (error) {
          console.log(error);
          setShowDataCriacao(true);
        }
      }
      // } else {
      //     toast.error('CNPJ invalido')
      // }
    }
  }

  function nextStep(e) {
    e.preventDefault()
    // console.log(dataCriacao)
    // console.log(formatISO(addHours(new Date(dataCriacao),3),{representation:"date"}));
    if (emailCadastro !== confirmaEmailCadastro)
      return toast.error('O email deve ser igual ao email de confirmação')

    if (phoneCadastro.length < 14)
      return toast.error('Número de celular inválido')
    if (fixoCadastro) {
      if (fixoCadastro.length < 14)
        return toast.error('Número de telefone inválido')
    }
    if (senhaCadastro.length <= 8)
      return toast.error('A senha deve conter mais de 8 dígitos')
    if (senhaCadastro !== senhaConfirmacao)
      return toast.error('As senhas informadas devem ser iguais')

    return setShowTermo(true)

  }

  const header = <h6>Digite novamente sua senha</h6>;

  const footer = (
    <React.Fragment>
      <Divider />
      <p className="p-mt-2 text-sm">* Mínimo de 9 caracteres</p>
    </React.Fragment>
  );

  useEffect(() => {
    consultaCNPJ(documentoCadastro)
  }, [])

  return (
    <>
      <div className="text-center px-5">
        {showTermo && <DialogTermo aceiteTermo={sendData}
          close={() => setShowTermo(false)} />}
        <form onSubmit={(e) => nextStep(e)} className="pl-2 grid gap-4">

          {/* <img src={paguelogo} alt="logo" className="mt-3"/> */}
          <h1 className="text-5xl mt-5"><b>Bem vindo à Direto!</b></h1>
          <h6 className="text-xl">Para realizar seu cadastro, precisamos que você nos forneça algumas informações</h6>
          <div className="grid text-left w-full mt-5 gap-6">
            <FloatLabel className="grid w-full">

              <InputText
                id="nome"
                type="text"
                className="w-full"
                required
                value={nomeCadastro}
                onChange={e => setNomeCadastro(e.target.value)}
              />
              <label htmlFor="nome">
                {documentoCadastro.length === 11 ? 'Nome Completo *' : 'Razão Social *'}</label>
            </FloatLabel>

            <FloatLabel className="grid w-full">

              <InputText
                id="email"
                type="email"
                className="w-full"
                required
                value={emailCadastro}
                onChange={e => setEmailCadastro(e.target.value)}
              />
              <label htmlFor="email">Email *</label>
            </FloatLabel>

            <FloatLabel className="grid w-full">

              <InputText
                id="email_confirmacao"
                type="email"
                className="w-full"
                required
                value={confirmaEmailCadastro}
                onChange={e => setConfirmaEmailCadastro(e.target.value)}
              />
              <label htmlFor="email_confirmacao">Confirme seu Email *</label>
            </FloatLabel>

            {showDataCriacao &&
              <FloatLabel className="grid w-full" pt={FloatLabelCalendar}>

                <Calendar
                  value={dataCriacao}
                  maxDate={today}
                  pt={CalendarPague}
                  locale="pt-BR"
                  dateFormat="dd/mm/yy"
                  placeholder=" "
                  onChange={(e) => setDataCriacao(e.value)}
                  yearNavigator
                  yearRange="1900:2025"
                  showOnFocus={false}
                  showIcon
                  icon={<FaCalendarAlt className={
                    classNames('px-4 rounded-r-lg',
                      'w-[50px] h-full',
                      'bg-sky-400 text-white hover:bg-sky-500',
                      'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                    )}
                  />}
                  id="data_criacao"
                  required
                  mask="99/99/9999"
                />

                <label htmlFor="data_criacao">Data de Criação *</label>
              </FloatLabel>}

            <FloatLabel className="grid w-full">

              <InputText
                id="numero"
                required
                className="w-full"
                value={phoneCadastro}
                onChange={({ target }) =>
                  setPhoneCadastro(
                    mask(unMask(target.value), [
                      '(99) 9999-9999',
                      '(99) 99999-9999'
                    ])
                  )
                }
              />
              <label htmlFor="celular">Celular *</label>
            </FloatLabel>

            <FloatLabel className="grid w-full">

              <InputText
                id="comercial"
                type="tel"
                className="w-full"
                value={fixoCadastro}
                // placeholder=""
                onChange={({ target }) =>
                  setFixoCadastro(
                    mask(unMask(target.value), [
                      '(99) 9999-9999'
                    ])
                  )
                }
              />
              <label htmlFor="comercial">Comercial</label>
            </FloatLabel>

            <FloatLabel pt={FloatLabelPassword} className="grid w-full">

              <Password
                id="senha"
                required
                className="w-full"
                pt={PasswordFullPague}
                value={senhaCadastro}
                onChange={e => setSenhaCadastro(e.target.value)}
                promptLabel="Crie uma senha"
                weakLabel="Fraca"
                mediumLabel="Média"
                strongLabel="Forte"
                footer={footer}
                toggleMask
              />
              <label htmlFor="senha">Senha *</label>
            </FloatLabel>

            <FloatLabel pt={FloatLabelPassword} className="grid w-full">
              <Password
                id="confirm"
                required
                pt={PasswordFullPague}
                className="w-full"
                value={senhaConfirmacao}
                onChange={e => setSenhaConfirmacao(e.target.value)}
                header={header}
                promptLabel=" "
                weakLabel="Fraca"
                mediumLabel="Média"
                strongLabel="Forte"
                toggleMask
              />
              <label htmlFor="confirm">Confirme sua Senha *</label>
            </FloatLabel>

            <small >
              Os campos marcados com * são obrigatórios</small>
            {/* <div className="w-full " >
                      <Checkbox id="cb" checked={aceite} onChange={e => setAceite(e.checked)} />
                      <label className="ml-2 " htmlFor="cb">* Aceito os <a href='/V2Cris_Protesto_Direto_-_Contrato_Credor.pdf' target='_blank' rel="noopener noreferrer" >Termos de Uso</a> e a <a href="/POLITICA_DE_PRIVACIDADE.pdf" target="_blank" rel="noopener noreferrer">Política de Privacidade</a> da DiretoTech</label>
                  </div> */}
            <div className="w-full justify-around flex">
              <div className="w-1/3">
                <Button
                  label="Continuar"
                  className="w-full"
                  severity="success"
                  type="submit"
                //disabled={!aceite}
                />
              </div>
              <div className="w-1/3" >
                <Button icon={<BiRefresh className="text-2xl" />}
                  severity="danger"
                  label="Refazer"
                  className="w-full"
                  tooltip="Refazer cadastro"
                  tooltipOptions={{ position: 'bottom' }}
                  onClick={() => { localStorage.clear(); navigate('/cadastro/passo0') }} />
              </div>
            </div>
            <div className=" w-full mb-4">
              <ProgressBar value={0} color='#4aa677' />
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default FirstContact
